import { makeAutoObservable, runInAction } from 'mobx';
import { store } from './store';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { subtaskKanbanOptions } from '../common/options/otherOptions/accessOptions';
import { historyPayloadType, updateHistoryMain } from '../models/history';

export default class KanbanStore {
  constructor() {
    makeAutoObservable(this);
  }
  KanbanArray: any[] = [];

  KanbanItemId: any = '';
  loadingkanbanData = false;
  viewpageTittle: any = ' ';
  kanbansubtaskLeftTittle: any = ' ';
  kanbansubtaskRightTittle: any = ' ';
  Kanban_backend_task_Data: any = '';
  kanbanItemSubtaksId: any;
  cardTriggerbtn: boolean = false;
  ModelTaskInfo: any;
  ModelSubtaskInfo: any;
  KanbancompleteTriggerBtn: boolean = false;
  KanbanDestinationId: number = 1;
  KanbanSourceId: number = 1;
  KanbanRedirectpage: boolean = false;

  loadKanbanData = async () => {
    this.loadingkanbanData = true;
    try {
      const items = await agent.KanbanList.Kanban();

      if (items[0].cards) {
        if (
          this.KanbanArray?.filter((element: any) => element?.includes('start'))
        ) {
          this.KanbanArray = items;
        } else {
          this.KanbanArray = items;
          this.KanbanArray = this.KanbanArray?.filter((element: any) =>
            element.includes('start'),
          );
        }
      }

      this.loadingkanbanData = false;
      this.KanbancompleteTriggerBtn = false;
    } catch (error) {
      this.loadingkanbanData = false;
      runInAction(() => {
        console.log(error);
      });
    }
  };

  findStatusData = (data: number) => {
    return subtaskKanbanOptions[data];
  };

  Kanbandatapass = async (
    item: any,
    itemTitle: string,
    fromData: any,
    toData: any,
  ) => {
    try {
      this.viewpageTittle = itemTitle;
      let kanbanId = await agent.KanbanList.KanbanData(item, toData);
      // let kanbanmodel = await agent.KanbanList.kanbanModel(this.KanbanItemId);
      let kanbanmodel = await agent.viewPage.activeOrder({
        itemId: this.KanbanItemId,
      });
      this.Kanban_backend_task_Data = kanbanmodel.data || [];
      this.Task_subtaskKanbanInfo(kanbanmodel.data || []);
      runInAction(() => {
        this.KanbanItemId = kanbanId.data;
        if (!this.KanbanItemId) return;

        const payload: historyPayloadType = {
          taskId: '',
          taskName: '',
          subTaskId: '',
          subTaskName: '',
          status: `${store.userStore.user
            ?.displayName} performed action on ${itemTitle}'s subtask ${
            this.kanbansubtaskLeftTittle
          } of task ${this.kanbansubtaskRightTittle} from ${this.findStatusData(
            fromData,
          )} to ${this.findStatusData(toData)} Successfully from Kanban page`,
          date: new Date(),
        };
        updateHistoryMain(payload, false, true);
        toast.success('Task Updated Successfully');
      });
    } catch (error) {
      console.log(error);
    }
  };

  kanbanitemIdAssigner = async (item: any) => {
    this.kanbanItemSubtaksId = ' ';
    try {
      const kanbanId = await agent.KanbanList.kanbanItemId(item);
      this.kanbanItemSubtaksId = kanbanId;
      runInAction(() => {
        this.cardTriggerbtn = true;
      });
    } catch (error) {
      console.log(error);
    }
  };

  Task_subtaskKanbanInfo = (item: any) => {
    const taskinfo = item?.tasks?.filter((data: any) => {
      return data?.isCurrentTask === true;
    });
    this.ModelTaskInfo = taskinfo?.[0];
    const subtaskinfo = taskinfo[0]?.subTasks?.filter((data: any) => {
      return data?.isCurrentSubtask === true;
    });
    this.ModelSubtaskInfo = subtaskinfo?.[0];
  };

  kanbanDestinationInfomation = (
    data: number,
    item: boolean,
    data2: number,
  ) => {
    this.KanbanDestinationId = data;
    this.KanbanRedirectpage = item;
    this.KanbanSourceId = data2;
  };
}
